<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Learning Goal</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Learning Goal</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="LearningGoal">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'LearningGoalList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label" for="name_english">Name (English)</label>
                    <input type="text" id="name_english" name="name"
                           v-bind:class="{'has-error' : errors.has('name')}"
                           v-validate="'required'"
                           v-model="value.name" class="form-control name"
                           placeholder="Name">
                    <div class="help text-danger" v-show="errors.has('name')">
                      {{ errors.first("name") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label" for="name_bn">Name (Bangla)</label>
                    <input type="text" id="name_bn" name="name_bn"
                           v-bind:class="{'has-error' : errors.has('name_bn')}"
                           v-validate="'required'"
                           v-model="value.name_bn" class="form-control"
                           placeholder="Name">
                    <div class="help text-danger" v-show="errors.has('name_bn')">
                      {{ errors.first("name_bn") }}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <h4 class="site-heading my-3"><span>Image</span></h4>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="thumbnail"></label>
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="input-group">
                          <div class="custom-file">
                            <input type="file" v-bind:class="{'has-error' : errors.has('thumbnail')}"
                                   v-validate=" temp_thumbnail ? '' : 'required' " name="thumbnail"
                                   class="custom-file-input"
                                   id="thumbnail" @change="selectThumbnail">
                            <label class="custom-file-label" for="thumbnail">{{ value.thumbnail_name }}</label>
                          </div>
                        </div>
                        <div class="help text-danger" v-show="errors.has('thumbnail')">
                          {{ errors.first("thumbnail") }}
                        </div>
                      </div>
                      <div class="col-8">
                        <img
                          alt="preview image"
                          v-if="temp_thumbnail"
                          v-bind:src="temp_thumbnail"
                          width="100"
                          height="100"
                          class="img-thumbnail"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Is published?</label>
                    <div class="form-group">
                      <el-select v-model="value.is_published" v-validate="'required'" name="is_published"
                                 style="width: 100%" placeholder="select published status">
                        <el-option
                          v-for="item in [{value: 'Yes', label: 'Yes'}, {value: 'No', label: 'No'}]"
                          :key="item.value" v-bind:class="{'has-error' : errors.has('is_published')}"
                          :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <div class="help text-danger" v-show="errors.has('is_published')">
                        {{ errors.first("is_published") }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Display order</label>
                    <input type="number" id="display_order" name="display_order"
                           v-model="value.display_order"
                           v-validate="'required|min:0|max:9999'"
                           class="form-control"
                           v-bind:class="{'has-error' : errors.has('display_order')}"
                           placeholder="Display order">
                    <div class="help text-danger" v-show="errors.has('display_order')">
                      {{ errors.first("display_order") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "LearningGoalForm",
  metaInfo: {
    title: "Learning Goal | Dotlines"
  },
  data: () => ({
    is_loading: false,
    is_edit: false,
    params: {},
    temp_thumbnail: '',
    value: {
      display_order: 9999,
      thumbnail: '', thumbnail_name: 'Choose file'
    },
  }),
  methods: {
    selectThumbnail: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
          this.value.thumbnail = reader.result;
          this.temp_thumbnail = reader.result;
          this.$set(this.value, 'thumbnail_name', event.target.files[0].name)
        };
      } catch (e) {
        //console.log(e);
      }
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/learning_goals";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/learning_goals/" + _this.$route.params.id
            method = "PUT";
          }
          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "LearningGoalList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/learning_goals/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
          this.temp_thumbnail = this.API_ASSET_UPLOAD_URL + this.value.thumbnail
        }).catch((error) => {
          console.log(error.response);
        });
        this.value.thumbnail = ''
      }
      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

